import { createContext, useContext } from "react";

export type ConfirmationModalContent = {
  title: string;
  body: string;
  confirmationCallback: () => void | Promise<void>;
};

type ModalContextResults = {
  showConfirmationModal: (modal: ConfirmationModalContent) => void;
  hideConfirmationModal: () => void;
};

export const ModalContext = createContext<ModalContextResults>(
  {} as ModalContextResults,
);

export const useModalContext = () => useContext(ModalContext);
